import React from "react";
import { Flex, Heading } from "@badi/badi-components";

import { usePremium } from "../hook";
import PremiumBlocker from "../blocker";
import PremiumLabel from "../label";
import PremiumInfo from "../info";

const PremiumFeature = ({
  children,
  contentOrder = 4,
  description = "",
  roomId,
  feature,
  customFeatureFlag = true,
  labelPosition = {},
  onInfoClick = null,
  title = "",
}) => {
  const { premiumEnabled, isPremium, hasCapability } = usePremium({
    roomId,
    capabilityId: feature,
  });

  const renderChildren = (props = {}) => {
    return typeof children === "function"
      ? children({ enabled: true, premium: true, ...props })
      : children;
  };

  if (!premiumEnabled || !customFeatureFlag) {
    return null;
  }

  if (!isPremium) {
    return renderChildren({ premium: false });
  }

  return (
    <Flex direction="column" gutter={1}>
      <PremiumLabel order={1} {...labelPosition} />
      {title && (
        <Heading data-qa="premium-title" level={3} order={2}>
          {title}
        </Heading>
      )}
      <PremiumInfo
        bottom={1}
        description={description}
        feature={feature}
        includeButton={!hasCapability}
        onClick={onInfoClick}
        order={3}
        roomId={roomId}
      />
      {hasCapability ? (
        <div order={contentOrder}>{renderChildren()}</div>
      ) : (
        <PremiumBlocker feature={feature} order={contentOrder} roomId={roomId}>
          {renderChildren({ enabled: false })}
        </PremiumBlocker>
      )}
    </Flex>
  );
};

export default PremiumFeature;
